import * as React from "react";
import { Outlet } from "react-router-dom";
import {
    makeStyles,
    Title3,
    Persona,
    tokens,
    Display,
} from "@fluentui/react-components";
import { useAuth } from "../../../auth/AuthProvider";
import { useRole } from "../RoleContext";
import Section from "../shared/Section";
import RoleSwitcher from "../shared/RoleSwitcher";
import { BookDatabaseColor } from "@fluentui/react-icons";

const useStyles = makeStyles({
    root: {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: tokens.colorNeutralBackground2,
    },
    header: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "16px",
        paddingBottom: "30px",
    },
    content: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        padding: "0 16px",
    },
    persona: {
        alignSelf: "center"
    }
});

const HomeLayout: React.FC = () => {
    const styles = useStyles();
    const { userName } = useAuth();
    const { activeRole } = useRole();

    return (
        <div className={styles.root}>
            <header className={styles.header}>
                <Display><BookDatabaseColor /></Display>
                <Title3>Data Enrichment</Title3>
            </header>
            <main className={styles.content}>
                {userName && (
                    <Section className={styles.persona}>
                        <Persona
                            name={userName}
                            secondaryText={activeRole}
                            size="medium"
                            textAlignment="center"
                        />
                        <div>
                            <RoleSwitcher />
                        </div>
                    </Section>
                )}

                <Section>
                    <Outlet />
                </Section>
            </main>
        </div>
    );
};

export default HomeLayout;
